import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';
import { initSearch } from '../apps/search/search';

export class Search extends AbstractComponent {
  init() {
    const searchConfig = JSON.parse(this.el.dataset.searchConfig);


    initSearch('#search-app', {
      searchConfig,
    });

  }
}

register('search', Search);
